import { ActivityStatus } from "./activityStatus";

export class EntityEvent<T> {
    public entity: T;
    public context: EntityEventContext;

    constructor(entitiy: T, context: EntityEventContext) {
        this.entity = entitiy;
        this.context = context;
    }
}

export class EntityEventContext {
    public type: string;

    constructor(eventType: string) {
        this.type = eventType;
    }
}

export class ActivityStatusChangeEventContext extends EntityEventContext {
    public oldStatus: ActivityStatus;
    public newStatus: ActivityStatus;

    constructor(newStatus: ActivityStatus, oldStatus: ActivityStatus) {
        super(EntityEventType.StatusChange);
        this.newStatus = newStatus;
        this.oldStatus = oldStatus;
    }
}

export class ActivityContextChangedEventContext extends EntityEventContext {
    public context: object;
    public updated: object;
    public removed: string[];

    constructor(context: string | object, updated: object, removed: string[]) {
        super(EntityEventType.ActivityContextChange);
        this.context = typeof context === "string" ? JSON.parse(context) : context;
        this.updated = updated;
        this.removed = removed;
    }
}

export class EntityEventType {
    public static Added = "added";
    public static Removed = "removed";
    public static Updated = "updated";
    public static Closed = "closed";
    public static StatusChange = "statusChange";
    public static ActivityContextChange = "activityContextUpdate";
    public static ActivityWindowEvent = "activityWindowEvent";
    // #deleteme TODO: these are not implemented in HC
    public static ActivityWindowJoinedActivity = "joined";
    public static ActivityWindowLeftActivity = "left";
}

export class ActivityState {
    public static Created = "created";
    public static Started = "started";
    public static Destroyed = "destroyed";
}
